import React, { Fragment } from "react";
import PropTypes from "prop-types";

const railOuterStyle = {
	position: "absolute",
	width: "100%",
	height: 2,
	transform: "translate(0%, -50%)",
	borderRadius: 7,
	cursor: "pointer",
};

const railInnerStyle = {
	position: "absolute",
	width: "100%",
	height: 2,
	transform: "translate(0%, -50%)",
	borderRadius: 7,
	pointerEvents: "none",
	backgroundColor: "#B9BAB6",
};

export const SliderRail = ({ getRailProps, outerStyle }) => {
	return (
		<Fragment>
			<div style={{ ...railOuterStyle, ...outerStyle }} {...getRailProps()} />
			<div style={railInnerStyle} />
		</Fragment>
	);
};

SliderRail.propTypes = {
	getRailProps: PropTypes.func.isRequired,
	outerStyle: PropTypes.object,
};

export const Handle = ({ domain: [min, max], handle: { id, value, percent }, disabled = false, getHandleProps }) => {
	return (
		<Fragment>
			<div
				style={{
					left: `${percent}%`,
					position: "absolute",
					transform: "translate(-50%, -50%)",
					WebkitTapHighlightColor: "rgba(0,0,0,0)",
					zIndex: 5,
					width: 28,
					height: 42,
					cursor: "pointer",
					backgroundColor: "none",
				}}
				{...getHandleProps(id)}
			/>
			<div
				role="slider"
				aria-valuemin={min}
				aria-valuemax={max}
				aria-valuenow={value}
				style={{
					left: `${percent}%`,
					position: "absolute",
					transform: "translate(-50%, -50%)",
					zIndex: 2,
					width: 12,
					height: 12,
					borderRadius: "50%",
					boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.3)",
					backgroundColor: disabled ? "#666" : "#3C3C3B",
				}}
			/>
		</Fragment>
	);
};

Handle.propTypes = {
	domain: PropTypes.array.isRequired,
	handle: PropTypes.shape({
		id: PropTypes.string.isRequired,
		value: PropTypes.number.isRequired,
		percent: PropTypes.number.isRequired,
	}).isRequired,
	getHandleProps: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};

export const Track = ({ source, target, getTrackProps, disabled = false }) => {
	return (
		<div
			style={{
				position: "absolute",
				transform: "translate(0%, -50%)",
				height: 2,
				zIndex: 1,
				backgroundColor: disabled ? "#999" : "#3C3C3B",
				borderRadius: 7,
				cursor: "pointer",
				left: `${source.percent}%`,
				width: `${target.percent - source.percent}%`,
			}}
			{...getTrackProps()}
		/>
	);
};

Track.propTypes = {
	source: PropTypes.shape({
		id: PropTypes.string.isRequired,
		value: PropTypes.number.isRequired,
		percent: PropTypes.number.isRequired,
	}).isRequired,
	target: PropTypes.shape({
		id: PropTypes.string.isRequired,
		value: PropTypes.number.isRequired,
		percent: PropTypes.number.isRequired,
	}).isRequired,
	getTrackProps: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};

const identity = (d) => d;

export const Tick = ({ tick, count, format = identity }) => {
	return (
		<div>
			<div
				style={{
					position: "absolute",
					marginTop: 2,
					width: 1,
					height: 5,
					backgroundColor: "rgb(200,200,200)",
					left: `${tick.percent}%`,
				}}
			/>
			<div
				style={{
					position: "absolute",
					marginTop: 6,
					fontSize: 10,
					textAlign: "center",
					marginLeft: `${-(100 / count) / 2}%`,
					width: `${100 / count}%`,
					left: `${tick.percent}%`,
				}}
			>
				{format(tick.value)}
			</div>
		</div>
	);
};

Tick.propTypes = {
	tick: PropTypes.shape({
		id: PropTypes.string.isRequired,
		value: PropTypes.number.isRequired,
		percent: PropTypes.number.isRequired,
	}).isRequired,
	count: PropTypes.number.isRequired,
	format: PropTypes.func,
};
